import { Stack } from "@mui/material";
import classnames from "classnames";
import { filter, find, first, get, sortBy } from "lodash";
import React from "react";
import * as styles from "./index.module.scss";
import { HOMEPAGE_TEMPLATE_KEY } from "../../../utils/constants";
import HomePoints from "../../HomePoints";
import { isTemplateEnabled } from "../../../logic/templates/isTemplateEnabled";
import TiersList from "../../LoyaltyProfile/tiers-list";
import HomeTitle from "../../HomeTitle";

function TitleComponent({ user, appStyles, pointBankCoupons, homepageImageSplit, enableFeedback, T, business, isMobile, businessAppConfiguration, currencySymbol, cashbackDiscounts }) {
  const renderHomePointsComponent = isTemplateEnabled(appStyles, HOMEPAGE_TEMPLATE_KEY.loyalty)  && user.loggedIn;
  const { homepageShowTiersList, homepageHidePoints } = appStyles;

  const tiers = filter(
    get(user, "loyaltyProfile.data.accumulativeCouponPoilcyRemainders"),
    (policy) => policy.type === "TIERS",
  );

  const nextTierData = first(
    sortBy(filter(tiers, (policy) => policy.remainder > 0), "remainder"),
  );

  const currentTierId = get(find(tiers, "isInGroup"), "groupId");

  // TODO: update this component NOT to be positioned as ABSOLUTE
  if (renderHomePointsComponent) {
    return (
      <Stack
        direction="column"
        p={1}
        spacing={1}
        sx={{
          position: "relative",
          top: 0,
          zIndex: 10,
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        {!homepageHidePoints && (
          <HomePoints
            T={T}
            desktopExtraTitle={T("{{desktop_extra_title}}")}
            appStyles={appStyles}
            className={classnames(
              !homepageImageSplit && enableFeedback && styles.HomeTitle
            )}
            user={user}
            pointBankCoupons={pointBankCoupons}
          />
        )}
        {homepageShowTiersList && isMobile && currentTierId && (
          <TiersList
            T={T}
            currencySymbol={business.currencySymbol}
            currentTierId={currentTierId}
            groups={business.groups}
            tiers={tiers}
            appStyles={appStyles}
            variant={"homePage"}
            user={user}
          />
        )}
        {get(businessAppConfiguration, "hasCashback", false) && get(appStyles, "cashbackTracker.enableCashbackTrackerOnHomepage", false) &&
        <CashbackTracker
          appStyles={appStyles}
          T={T}
          cashbackDiscounts={cashbackDiscounts}
          currencySymbol={currencySymbol}
          appCurrencySymbol={currencySymbol}
          hasClearBackground={true}
        />
      }
      </Stack>
    );
  }

  return (
    <HomeTitle
      T={T}
      title={T("Welcome to")}
      desktopExtraTitle={T("{{desktop_extra_title}}")}
      appStyles={appStyles}
      className={classnames(!homepageImageSplit && enableFeedback && styles.HomeTitle)}
    />
  )
}

export default TitleComponent;